import { useEffect, useMemo, useState } from "react";
import { Building2, Truck } from "lucide-react";
import apiClient from "../../services/api";
import TypeAheadInput from "../shared/TypeAheadInput";

const slug = (s) => s.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
const names = (list) => [...new Set((list || []).map((x) => (x.name || "").trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));

// Company type-ahead: suggestions are the General Contractors + Suppliers from Settings; anything typed is accepted.
const CompanyPicker = ({ value, onChange, id, testId = "contact-company", placeholder = "Company" }) => {
  const [lists, setLists] = useState({ gcs: [], suppliers: [] });
  useEffect(() => {
    apiClient.get(`/settings/options`).then((r) => setLists({ gcs: names(r.data.general_contractors), suppliers: names(r.data.suppliers) })).catch(() => {});
  }, []);
  const options = useMemo(() => [
    ...lists.gcs.map((name) => ({ name, kind: "gc", meta: "GC", icon: <Building2 className="w-3.5 h-3.5 text-muted-foreground shrink-0" /> })),
    ...lists.suppliers.map((name) => ({ name, kind: "supplier", meta: "Supplier", icon: <Truck className="w-3.5 h-3.5 text-muted-foreground shrink-0" /> })),
  ], [lists]);
  return <TypeAheadInput id={id} value={value} onChange={onChange} options={options} placeholder={placeholder} testId={testId} optionTestId={(o) => `company-option-${o.kind}-${slug(o.name)}`} />;
};

export default CompanyPicker;
